<template>
  <span :class="'icon' + (size ? ' icon--' + size : '')">
    <component :is="iconComponent"></component>
  </span>
</template>
<script>
// TODO: lacy loading - for now all icons will be added to tne app.js
import M4BankTransferSvg from "./icons/bank-transfer";
import M4PaypalSvg from "./icons/paypal";
import M4CreditCardSvg from "./icons/credit-card";

import M4CloseSvg from "./icons/close";
import M4CloseAltSvg from "./icons/close-alt";
import M4CloseCircleSvg from "./icons/close-circle";
import M4EditSvg from "./icons/edit";
import M4UserSvg from "./icons/user";
import M4UsersSvg from "./icons/users";
import M4LogOutSvg from "./icons/log-out";

import M4ArrowLeftSvg from "./icons/arrow-left";
import M4ArrowRightSvg from "./icons/arrow-right";

import M4AngleRightSvg from "./icons/angle-right";
import M4AngleLeftSvg from "./icons/angle-left";
import M4AngleLeftAltSvg from "./icons/angle-left-alt.vue";
import M4AngleRightAltSvg from "./icons/angle-right-alt.vue";
import M4AngleUpSvg from "./icons/angle-up";
import M4AngleDownSvg from "./icons/angle-down";

import M4PaperClipSvg from "./icons/paper-clip.vue";
import M4ListSvg from "./icons/list.vue";
import M4ListAltSvg from "./icons/list-alt.vue";

import M4FolderSvg from "./icons/folder";
import M4TachometerSvg from "./icons/tachometer";
import M4PlusSvg from "./icons/plus";
import M4SearchSvg from "./icons/search";
import M4SaveSvg from "./icons/save";
import M4ExportSvg from "./icons/export";
import M4ImportSvg from "./icons/import";
import M4DownloadSvg from "./icons/download";

import M4EllipsisVSvg from "./icons/ellipsis-v";
import M4FileAltSvg from "./icons/file-alt";
import M4EditAltSvg from "./icons/edit-alt";
import M4TrashSvg from "./icons/trash";
import M4SortSvg from "./icons/sort";
import M4InfoSvg from "./icons/info";
import M4InfoAltSvg from "./icons/info-alt";
import M4ExclamationSvg from "./icons/exclamation";
import M4UploadSvg from "./icons/upload";
import M4BellSvg from "./icons/bell";
import M4QuestionSvg from "./icons/question";
import M4CheckSvg from "./icons/check";
import M4CheckThinSvg from "./icons/check-thin";
import M4ClockSvg from "./icons/clock";
import M4IdBadgeSvg from "./icons/id-badge";
import M4SurveySvg from "./icons/survey";
import M4AddressSvg from "./icons/address";
import M4StandSvg from "./icons/stand";
import M4FileAltLightSvg from "./icons/file-alt-light";
import M4ExclamationAltSvg from "./icons/exclamation-alt";
import M4CheckAltSvg from "./icons/check-alt";
import M4DoorSvg from "./icons/door";
import M4PlaneAltSvg from "./icons/plane-alt";
import M4PlaneSvg from "./icons/plane";
import M4CartSvg from "./icons/cart";
import M4PrintSvg from "./icons/print";
import M4CogSvg from "./icons/cog";
import M4LockSvg from "./icons/lock";
import M4EnvelopeSvg from "./icons/envelope";
import M4AddCommentSvg from "./icons/add-comment";
import M4PaperStackSvg from "./icons/paper-stack";
import M4CalendarSvg from "./icons/calendar";
import M4CopySvg from "./icons/copy";
import M4AwardSvg from "./icons/award";
import M4StarSvg from "./icons/star";
import M4FlagSvg from "./icons/flag";
import M4AllDirectionsSvg from "./icons/all-directions.vue";
import M4StopFreeSvg from "./icons/stop-free.vue";
import M4UserAltSvg from "./icons/user-alt.vue";
import M4CheckboxSvg from "./icons/checkbox.vue";
import M4CheckboxMarkedSvg from "./icons/checkbox-marked.vue";
import M4FaceIdSvg from "./icons/face-id.vue";
import M4FingerPrintSvg from "./icons/finger-print.vue";
import M4VisibleSvg from "./icons/visible.vue";
import M4InvisibleSvg from "./icons/invisible.vue";

export default {
  name: "M4Icon",
  components: {
    M4BankTransferSvg,
    M4CreditCardSvg,
    M4PaypalSvg,
    M4CloseSvg,
    M4CloseAltSvg,
    M4EditSvg,
    M4UserSvg,
    M4ArrowLeftSvg,
    M4ArrowRightSvg,
    M4PaperClipSvg,
    M4LogOutSvg,
    M4ListSvg,
    M4ListAltSvg,
    M4AngleRightSvg,
    M4AngleLeftSvg,
    M4AngleLeftAltSvg,
    M4AngleRightAltSvg,
    M4FolderSvg,
    M4TachometerSvg,
    M4PlusSvg,
    M4SearchSvg,
    M4SaveSvg,
    M4ExportSvg,
    M4ImportSvg,
    M4DownloadSvg,
    M4EllipsisVSvg,
    M4FileAltSvg,
    M4EditAltSvg,
    M4TrashSvg,
    M4SortSvg,
    M4AngleDownSvg,
    M4AngleUpSvg,
    M4InfoSvg,
    M4InfoAltSvg,
    M4ExclamationSvg,
    M4UploadSvg,
    M4BellSvg,
    M4UsersSvg,
    M4QuestionSvg,
    M4CheckSvg,
    M4ClockSvg,
    M4IdBadgeSvg,
    M4SurveySvg,
    M4AddressSvg,
    M4StandSvg,
    M4FileAltLightSvg,
    M4ExclamationAltSvg,
    M4CheckAltSvg,
    M4DoorSvg,
    M4PlaneAltSvg,
    M4PlaneSvg,
    M4CartSvg,
    M4PrintSvg,
    M4CogSvg,
    M4LockSvg,
    M4EnvelopeSvg,
    M4AddCommentSvg,
    M4PaperStackSvg,
    M4CalendarSvg,
    M4CloseCircleSvg,
    M4CheckThinSvg,
    M4CopySvg,
    M4AllDirectionsSvg,
    M4AwardSvg,
    M4StarSvg,
    M4FlagSvg,
    M4StopFreeSvg,
    M4UserAltSvg,
    M4CheckboxSvg,
    M4CheckboxMarkedSvg,
    M4FaceIdSvg,
    M4FingerPrintSvg,
    M4VisibleSvg,
    M4InvisibleSvg
  },

  props: {
    icon: String,
    size: String
  },
  computed: {
    iconComponent() {
      return "m4-" + this.icon + "-svg";
    }
  }
};
</script>

<style scoped></style>
